import { useSelector } from 'react-redux';
import CareerAccordianJobList from './CareerAccordianJobList'
import CareerInfoDuoBox from './CareerInfoDuoBox'
import CareerStaticPositionCard from './CareerStaticPositionCard'

function CareerWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_careers === "accordion-job-list" ? (
        <CareerAccordianJobList />
      ) : sitedata?.theme_careers === "info-box-duo" ? (
        <CareerInfoDuoBox />
      ) : sitedata?.theme_careers === "static-position-card" ? (
        <CareerStaticPositionCard />
      ) : (
        <CareerStaticPositionCard />
      )}
 {/* <CareerInfoDuoBox /> */}
    </>
  )
}

export default CareerWrapper